import React from 'react';
import { Bar, Scatter } from 'react-chartjs-2';
import { Chart as ChartJS } from 'chart.js/auto';

function Graph(props) {
  return (
    <Bar data={props.chartData} style={{width: '80vw', aspectRatio: '1/1', marginLeft: '0%', marginRight: '5%'}}/>
  );
}

export default Graph